// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"329":"e79cb323","2895":"a19115ba","12589":"d8456254","89103":"f58203c0"}[chunkId] + ".css";
};